// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Service_serviceCard__ELL8K {
  margin-bottom: 20px;
}
.Service_serviceCard__ELL8K .ant-card-head-title {
  font-weight: bold;
}

.Service_statusActive__h99NE {
  color: #52c41a;
}

.Service_statusInactive__8PR35 {
  color: #d9d9d9;
}

.Service_statusFailed__aO0Lv {
  color: #ff4d4f;
}

.Service_filterControls__u\\+6vA {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.Service_serviceDescription__AYSpC {
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/pages/Detail/component/service/Service.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAEI;EACE,iBAAA;AAAN;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAFF","sourcesContent":[".serviceCard {\n  margin-bottom: 20px;\n  \n  :global {\n    .ant-card-head-title {\n      font-weight: bold;\n    }\n  }\n}\n\n.statusActive {\n  color: #52c41a;\n}\n\n.statusInactive {\n  color: #d9d9d9;\n}\n\n.statusFailed {\n  color: #ff4d4f;\n}\n\n.filterControls {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.serviceDescription {\n  max-width: 400px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"serviceCard": `Service_serviceCard__ELL8K`,
	"statusActive": `Service_statusActive__h99NE`,
	"statusInactive": `Service_statusInactive__8PR35`,
	"statusFailed": `Service_statusFailed__aO0Lv`,
	"filterControls": `Service_filterControls__u+6vA`,
	"serviceDescription": `Service_serviceDescription__AYSpC`
};
export default ___CSS_LOADER_EXPORT___;
